import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "dropdown" }
const _hoisted_5 = { class: "dropdown-menu" }
const _hoisted_6 = { class: "dropdown ms-3" }
const _hoisted_7 = { class: "dropdown-menu" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_10 = { class: "table-responsive" }
const _hoisted_11 = { class: "text-nowrap align-middle mb-0 table" }
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text pe-0" }
const _hoisted_18 = { class: "dropdown" }
const _hoisted_19 = { class: "dropdown-menu" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[8] || (_cache[8] = _createElementVNode("button", {
            class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
            "data-bs-toggle": "dropdown",
            "aria-expanded": "false"
          }, [
            _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }),
            _createTextVNode(" Ajouter une opération ")
          ], -1)),
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/ajouter-encaissement",
                class: "dropdown-item d-flex align-items-center"
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode(" Ajouter un encaissement ")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/ajouter-decaissement",
                class: "dropdown-item d-flex align-items-center"
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode(" Ajouter un décaissement ")
                ])),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[9] || (_cache[9] = _createElementVNode("button", {
            class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-primary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
            "data-bs-toggle": "dropdown",
            "aria-expanded": "false"
          }, " Filtrer par type ", -1)),
          _createElementVNode("ul", _hoisted_7, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "javascript:void(0);",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setFilter('toutes')))
              }, "Toutes")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "javascript:void(0);",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setFilter('encaissement')))
              }, "Encaissements")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "javascript:void(0);",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setFilter('decaissement')))
              }, "Décaissements")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("form", {
          class: "search-box position-relative me-20",
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onKeyup: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
            class: "form-control shadow-none text-black rounded-0 border-0",
            placeholder: "Rechercher une opération"
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("button", {
            type: "submit",
            class: "bg-transparent text-primary transition p-0 border-0"
          }, [
            _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
          ], -1))
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("table", _hoisted_11, [
          _cache[15] || (_cache[15] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Type d'opération "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Client "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Montant "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Motif "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Référence "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
              }, " Actions ")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOperations, (op) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: op.id
              }, [
                _createElementVNode("td", _hoisted_12, _toDisplayString(op.type), 1),
                _createElementVNode("td", _hoisted_13, _toDisplayString(op.client?.nom || '-'), 1),
                _createElementVNode("td", _hoisted_14, _toDisplayString(op.montant || 0) + " Fcfa ", 1),
                _createElementVNode("td", _hoisted_15, _toDisplayString(op.motif?.nom || '-'), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(op.referenceDoc || '-'), 1),
                _createElementVNode("td", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _cache[13] || (_cache[13] = _createElementVNode("span", {
                      class: "badge text-white bg-primary fs-15 dropdown-toggle",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, [
                      _createTextVNode(" Actions "),
                      _createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
                    ], -1)),
                    _createElementVNode("ul", _hoisted_19, [
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, {
                          to: `/billetage/${op.type.toLowerCase()}/${op.id}`,
                          class: "dropdown-item d-flex align-items-center"
                        }, {
                          default: _withCtx(() => _cache[11] || (_cache[11] = [
                            _createElementVNode("i", { class: "flaticon-eye lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode(" Afficher les détails de l'opération ")
                          ])),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      (_ctx.checkPermission('delete_operation'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                            _createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);",
                              onClick: ($event: any) => (_ctx.deleteOperation(op.id))
                            }, _cache[12] || (_cache[12] = [
                              _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Supprimer ")
                            ]), 8, _hoisted_21)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            }), 128)),
            (_ctx.filteredOperations.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_22, _cache[14] || (_cache[14] = [
                  _createElementVNode("td", {
                    colspan: "6",
                    class: "text-center text-muted"
                  }, " Aucune opération trouvée. ", -1)
                ])))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}